module.exports = __webpack_public_path__ + "img/libera.c9c96616.svg";